/**
 * PastOrdersButton - Floating Action Button for accessing past orders
 */

import React from 'react';

interface PastOrdersButtonProps {
	count: number;
	onClick: () => void;
}

export const PastOrdersButton: React.FC< PastOrdersButtonProps > = ( {
	count,
	onClick,
} ) => {
	return (
		<button
			type="button"
			className="sprintry-past-orders-button"
			onClick={ onClick }
			aria-label="Past orders"
		>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<circle cx="12" cy="12" r="10" />
				<polyline points="12 6 12 12 16 14" />
			</svg>
			{ /* 			{count > 0 && (
				<span className="sprintry-past-orders-button__badge">
					{count > 99 ? '99+' : count}
				</span>
			)} */ }
		</button>
	);
};
